import { render, staticRenderFns } from "./YzDatePicker.vue?vue&type=template&id=1bfd1389&scoped=true&lang=pug&"
import script from "./YzDatePicker.vue?vue&type=script&lang=js&"
export * from "./YzDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./YzDatePicker.vue?vue&type=style&index=0&id=1bfd1389&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd1389",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})
